import React, { Component } from 'react'
import MenuMList from './MenuMList'


export default class MenuM extends Component {

    state = {
        isOpen : false
    }

    openFx = () => {

        if(this.state.isOpen) {

            this.setState(
                { isOpen : false }
            )
        } else {

            this.setState(
                { isOpen : true }
            )
        }
    }   

    render() {

        return (

            <React.Fragment>

                <div id='MMenuIcon' onClick={this.openFx}>

                    <i className='material-icons'>apps</i>

                </div>

                { this.state.isOpen ? <MenuMList closeMe = {this.openFx} /> : null }
                
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/menu/MenuM.js